import { forwardRef, type ReactNode } from 'react';
import styles from './style.module.scss';
import { buildClassName } from 'utils/build-class-name';

interface ControlButtonProps {
  handler: () => void;
  children: ReactNode;
  desktopOnly?: boolean;
  mobileOnly?: boolean;
  isActive?: boolean;
  testId?: string;
  className?: string;
  ariaLabel?: string;
}

const ControlButton = forwardRef<HTMLSpanElement, ControlButtonProps>(function ControlButton(
  {
    handler,
    children,
    desktopOnly,
    mobileOnly,
    isActive,
    testId,
    className,
    ariaLabel,
  },
  ref
) {
  return (
    <span
      ref={ref}
      onClick={handler}
      role={ariaLabel ? 'button' : undefined}
      aria-label={ariaLabel}
      className={buildClassName(
        styles.control,
        desktopOnly && styles['desktop-only'],
        mobileOnly && styles['mobile-only'],
        isActive && styles.active,
        className
      )}
      data-testid={testId}
    >
      {children}
    </span>
  );
});

export default ControlButton;
